import { RecordTagColour, TagDTO, TagEntity } from '@gearbelt/global';
import { ColumnHelper } from '@tanstack/react-table';

import { ApiService } from '@/services/api-v2';

import { TagBadges } from './tag-badges';

export function createTagsColumn<T extends { tags?: TagDTO[] | null }>(
  columnHelper: ColumnHelper<T>,
  {
    header,
    entity,
    variant,
    canFilterUntagged = false,
  }: {
    header: string;
    entity: Exclude<TagEntity, TagEntity.Asset>;
    variant: RecordTagColour;
    // Only when the list API filters "no tags"; otherwise the "-" option silently returns every row.
    canFilterUntagged?: boolean;
  },
) {
  return columnHelper.accessor((row) => row.tags, {
    id: 'tags',
    header,
    enableGrouping: false,
    enableSorting: false,
    cell: ({ getValue }) => <TagBadges tags={getValue()} variant={variant} />,
    enableColumnFilter: true,
    meta: {
      filterType: 'async-multi-select',
      disableNullFilter: !canFilterUntagged,
      getFilterOptionsFn: async () => {
        const response = await (await ApiService.GetTags({ limit: 500, filters: { fields: { entity } } })).json();
        return response.data.map((tag) => ({
          label: tag.tag,
          value: tag.id,
        }));
      },
    },
  });
}
